<!--
 * @FileDescription: SKU映射列表
 * @Author: 陈文景
 * @Date: 2023-03-22 10:39:24
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <PageSkeletonTwo>
    <template slot="header-left">
      <el-select v-model="parameter.platformName" clearable size="medium" placeholder="适用平台" @change="getReplacesList" style="width:160px">
        <el-option v-for="item in platformOptions" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>

      <el-select v-model="parameter.userGroup" size="medium" clearable placeholder="用户分组" @change="getReplacesList" style="width:120px">
        <el-option label="默认" :value="-1" />
        <el-option label="独立站" :value="100" />
      </el-select>
      <el-select v-model="parameter.userIds" size="medium" collapse-tags multiple filterable remote reserve-keyword placeholder="邮箱/手机号" class="default-maggin-left" style="width: 200px;" @change="getReplacesList" :remote-method="userRemoteMethod" :loading="getUserLoading" @blur="userRemoteMethod" clearable>
        <el-option v-for="item in userOptions" :key="item.userId" :label="`${item.email||''}${(item.email&&item.phone?' / ':'')}${item.phone||''}`" :value="item.userId" :title="`${item.email||''}${item.phone?' / '+item.phone:''}`" />
      </el-select>

      <el-select v-model="parameter.openStatus" clearable size="medium" placeholder="状态" @change="getReplacesList" style="width:100px">
        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>

      <BatchSearch :option="searchOptins" :selected="parameter.searchType" @select="handleSelectSearchType" @search="handleBatchSearch" @clear="handleClearSearchValue" />
    </template>

    <template slot="header-right">
      <el-button :disabled="!replaces.length" size="medium" @click="handleExport">导出<i class="el-icon-download"/></el-button>
      <el-button size="medium" @click="handleImport">导入<i class="el-icon-upload2"/></el-button>
      <el-button type="primary" size="medium" @click="handleAddRole">新增规则</el-button>
    </template>

    <template slot="container">
      <el-table :data="replaces" v-loading="loading" style="width: 100%">
        <el-table-column label="适用平台" fixed="left" width="150">
          <template v-slot="{ row }">
            <div v-if="typeof row.platformName === 'string'">
              <el-tooltip v-if="row.platformName.includes(',')" placement="top">
                <div slot="content">
                  <div v-for="(t, i) in row.platformName.split(',')" :key="'name'+i">{{ t }}</div>
                </div>
                <div>{{ `${row.platformName.split(',')[0]}...` }}</div>
              </el-tooltip>
              <div v-else>{{ row.platformName === 'Entire' ? '全平台' : row.platformName }}</div> 
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="userGroup" label="用户分组" width="100">
          <template v-slot="{ row }">
            <div>{{ row.userGroup === -1 ? '默认' : row.userGroup === 100 ? '独立站' : '' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="userGroup" label="kaka账号">
          <template v-slot="{ row }">
            <div>{{ row.showName || '-' }}</div>
          </template>
        </el-table-column>

        <el-table-column prop="beforeSku" label="平台SKU" />
        <el-table-column prop="afterSku" label="公司SKU">
          <template v-slot="{ row }">
            <div v-if="row.skuReplaceDetails && row.skuReplaceDetails.length">
              <div v-if="row.skuReplaceDetails.length === 1">{{ `${row.skuReplaceDetails[0].afterSku} x${row.skuReplaceDetails[0].skuNum}` }}</div>
              <el-tooltip v-else placement="top">
                <div slot="content">
                  <div v-for="(t, i) in row.skuReplaceDetails" :key="i">{{ `${t.afterSku} x${t.skuNum}` }}</div>
                </div>
                <div>{{ `${row.skuReplaceDetails[0].afterSku} x${row.skuReplaceDetails[0].skuNum}...` }}</div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="orderNum" label="替换订单数" />
        <el-table-column prop="orderSkuNum" label="替换SKU数" /> -->
        <el-table-column label="状态" width="90">
          <template v-slot="{ row }">
            <el-switch v-model="row.openStatus" :active-value="true" :inactive-value="false" @change="(value) => onChangeStatusSwitch(value, row)" />
          </template>
        </el-table-column>
        <el-table-column prop="modifier" label="最后修改邮箱" show-overflow-tooltip />
        <el-table-column label="最后修改时间" show-overflow-tooltip width="170">
          <template v-slot="{ row }">
            {{ defaultTips(formatTimeStamp(row.modifyDate)) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template v-slot="{ row }">
            <a href="javascript:;" class="details" @click="() => handleEditMapReplace(row)">修改</a>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <template #footer-right>
      <el-pagination :page-sizes="[20, 50, 100, 200]" background layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="currentChange" />
    </template>

    <!-- 新增规则对话框 -->
    <AddOrEditRoleDialog ref="AddOrEditRoleDialog" @success="success" />

    <!-- 导入对话框 -->
    <ImportExcel ref="importExcel" :confirmLoading="importExcelLoading" @download="onDownloadTemplate" @import="importAffirm" />
  </PageSkeletonTwo>
</template>

<script>
import API from '@/api'
import { formatTimeStamp } from '@/utils/moment'
import ImportExcel from '@/components/ImportExcel.vue'
import BatchSearch from './components/BatchSearch.vue'
import PageSkeletonTwo from '@/components/PageSkeletonTwo.vue'
import AddOrEditRoleDialog from './components/AddOrEditRoleDialog.vue'

export default {
  name: 'orders_sku-replace',
  components: {
    BatchSearch,
    ImportExcel,
    PageSkeletonTwo,
    AddOrEditRoleDialog
  },
  data() {
    return {
      formatTimeStamp, // 把时间戳格式化为时间字符串

      // 列表请求参数
      parameter: {
        platformName: undefined, // 适用平台
        openStatus: undefined, // 状态
        searchType: 1, // 批量搜索的类型
        searchContexts: [], // 搜索的值集合
        pageNumber: 1,
        pageSize: 20
      },

      // 适用平台下拉选项
      platformOptions: [
        { label: '全平台', value: 'Entire' },
        { label: 'Shopify', value: 'Shopify' },
        { label: 'Shoplazza', value: 'Shoplazza' },
        { label: 'Shopline', value: 'Shopline' },
        { label: 'Woocommerce', value: 'Woocommerce' }
      ],

      // 状态下拉选项
      statusOptions: [
        { label: '开启', value: true },
        { label: '关闭', value: false }
      ],

      // 批量搜索下拉选项
      searchOptins: [
        { label: '平台SKU', value: 1 },
        { label: '公司SKU', value: 2 }
      ],

      replaces: [
        { id: 1, platformName: 1, beforeSku: '10001', afterSku: 'FSZW07386_GR_M_NUB', orderNum: 100, orderSkuNum: 100, openStatus: 0, modifier: '123456@qq.com', modifyDate: 1679453519000 },
        { id: 1, platformName: 2, beforeSku: '10001', afterSku: 'FSZW07386_GR_M_NUB', orderNum: 100, orderSkuNum: 100, openStatus: 0, modifier: '123456@qq.com', modifyDate: 1679453519000 }
      ], // SKU替换列表
      total: 0, // 总数据量
      loading: false, // 表格加载效果

      importExcelLoading: false, // 导入对话框 - 确定按钮的加载效果

      getUserLoading: false,
      userOptions: []
    }
  },
  computed: {
    platformName() {
      return (type) => {
        switch (type) {
          case 'Entire':
            return '全平台'
          case 'Shopify':
            return 'Shopify'
          case 'Shoplazza':
            return 'Shoplazza'
          case 'Shopline':
            return 'Shopline'
          case 'Woocommerce':
            return 'Woocommerce'
          default:
            return '-'
        }
      }
    },
    defaultTips() {
      return (value) => value || '-'
    }
  },
  created() {
    this.getReplacesList()
  },
  activated() {
    this.getReplacesList()
  },
  mounted() {
    this.getUserOptions()
  },
  methods: {
    /**
     * API 获取售后订单列表
     *
     * @param {Boolean} reset 是否重置分页
     */
    async getReplacesList(reset = true) {
      try {
        if (reset) {
          this.parameter.pageNumber = 1
        }
        this.loading = true
        let query = { ...this.parameter }
        let { data } = await API.getReplacesList(query)
        this.total = data.total
        this.replaces = data.list
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    /**
     * 选择搜索类型的回调
     *
     * @param {String} value 当前选中的值
     */
    handleSelectSearchType(value) {
      this.parameter.searchType = value
      if (this.parameter.searchContexts.length) {
        this.getReplacesList()
      }
    },

    /**
     * 搜索按钮触发的回调
     *
     * @param {String} value 关键字数组
     */
    handleBatchSearch(value) {
      this.parameter.searchContexts = [...value]
      if (this.parameter.searchContexts.length) {
        this.getReplacesList()
      } else {
        this.handleClearSearchValue()
      }
    },

    /**
     * 批量搜索框的清除事件的回调
     */
    handleClearSearchValue() {
      this.parameter.searchContexts = []
      this.getReplacesList()
    },

    /**
     * 导入
     */
    handleImport() {
      this.$refs.importExcel.show() // 显示导出对话框方法
    },

    /**
     * 导入对话框 - 下载模板的回调事件
     */
    onDownloadTemplate() {
      API.getSystemImport({ dictTypeCode: 'data:sku_replace_import_template' }).then(res => {
        window.open(res.data)
      })
    },

    // /**
    //  * 导入对话框 - 确定按钮的回调事件
    //  *
    //  * @param file 导入文件的二进制流
    //  */
    // onImportAffirm(file) {
    //   console.log(file)
    //   try {
    //     this.importExcelLoading = true
    //     // 此处调用导入的接口
    //     // 导入成功后调用this.$refs.ImportExcel.close()该方法关闭对话框即可
    //     // this.$refs.ImportExcel.close() // 关闭导出对话框方法
    //     this.importExcelLoading = false
    //   } catch (error) {
    //     this.importExcelLoading = false
    //   }
    // },

    importAffirm(filePath) {
      this.confirmLoading = true
      this.importExportFile({
        fileType: 1,
        taskType: 2,
        fileName: 'Sku替换信息导入', // this.$store.getters.userId,
        filePath
      })
    },
    // 导入导出
    importExportFile(param) {
      API.importExportFile(param).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message) 
        this.$refs.importExcel.close()
        this.$message.success('操作成功，请到导入导出管理查看')
      }).finally(() => {
        this.confirmLoading = false
      })
    },

    /**
     * 导出
     */
    handleExport() {
      // 导出上架失败原因
      let newParameter = { ...this.parameter }
      delete newParameter.pageNumber
      delete newParameter.pageSize
      API.importExportFile({ fileType: 2, taskType: 29, condition: JSON.stringify(newParameter) }).then(() => {
        this.$message.success('用户数据导出成功,请前往导入导出中心查看进度')
      })
    },

    /**
     * 新增规则按钮的回调事件
     */
    handleAddRole() {
      this.$refs.AddOrEditRoleDialog.show()
    },

    /**
     * 开启或关闭规则触发的事件回调
     *
     * @param {Number} value 新状态的值
     * @param {Object} row 当前点击的行信息
     */
    onChangeStatusSwitch(value, row) {
      API.orderSkuOpenStatus({
        id: row.id,
        openStatus: value
      }).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message) 
        this.getReplacesList()
        this.$message.success('操作成功')
      })
    },

    /**
     * 修改SKU替换规则
     *
     * @param {Object} row 当前点击的行信息
     */
    handleEditMapReplace(row) {
      this.$refs.AddOrEditRoleDialog.show({ ...row })
    },

    /**
     * 每页显示数量发生改变时的回调
     *
     * @param size 每页显示数量
     */
    sizeChange(size) {
      this.parameter.pageSize = size
      this.getReplacesList(false)
    },

    /**
     * 上一页/下一页/当前页发生改变时的回调
     *
     * @param current 当前页
     */
    currentChange(current) {
      this.parameter.pageNumber = current
      this.getReplacesList(false)
    },

    success() {
      this.getReplacesList()
    },

    async userRemoteMethod(query) {
      const params = {
        email: query ? query.trim() : '', // 查询关键字
        pageNumber: 1,
        pageSize: 20,
        users: [],
        // userIds: this.parameter.userIds || []
      }
      this.getUserLoading = true
      let result = await API.getUserOptions(params)
      this.userOptions = result.data.list
      this.getUserLoading = false
    },
    getUserOptions() {
      if (!this.userOptions.length) this.userRemoteMethod()
    },
  }
}
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
  outline: none;
  &.details {
    color: #99c41c;
  }
  &.process {
    color: #eb5757;
  }
}
.default-maggin-left {
  /deep/ .el-tag {
    max-width: 100px;
  }
}
</style>
